import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  analyticsApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { snykApiRef, SnykApiClient } from 'backstage-plugin-snyk';
import { GoogleAnalytics4 } from '@backstage-community/plugin-analytics-module-ga4';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import {
  repoLensApiRef,
  RepoLensClient,
  RepoLensTechRadarApi,
} from '@internal/plugin-repo-lens-frontend';
import { resilientScaffolderApiFactory } from './components/scaffolder/CustomTaskLogStream';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: snykApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, fetchApi, configApi }) =>
      new SnykApiClient({
        discoveryApi,
        fetchApi,
        configApi,
        proxyPathBase: '',
      }),
  }),
  createApiFactory({
    api: analyticsApiRef,
    deps: { configApi: configApiRef, identityApi: identityApiRef },
    factory: ({ configApi, identityApi }) =>
      GoogleAnalytics4.fromConfig(configApi, {
        identityApi,
      }),
  }),
  // Repo Lens API
  createApiFactory({
    api: repoLensApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) =>
      new RepoLensClient({ discoveryApi, fetchApi }),
  }),
  // Tech Radar API backed by Repo Lens data
  createApiFactory({
    api: techRadarApiRef,
    deps: { repoLensApi: repoLensApiRef },
    factory: ({ repoLensApi }) => new RepoLensTechRadarApi(repoLensApi),
  }),
  // Custom resilient scaffolder API with better error handling
  resilientScaffolderApiFactory,
];
